import * as Sentry from "@sentry/react";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

const ErrorFallback: Sentry.FallbackRender = ({ error, resetError }) => (
  <div className="flex min-h-screen items-center justify-center bg-background">
    <div className="text-center space-y-4 p-8">
      <AlertTriangle className="h-16 w-16 text-destructive mx-auto" />
      <h1 className="text-2xl font-bold">Algo deu errado</h1>
      <p className="text-muted-foreground max-w-md">
        Desculpe, encontramos um erro inesperado. Nossa equipe foi notificada.
      </p>
      <div className="flex gap-2 justify-center">
        <Button onClick={resetError}>
          Tentar novamente
        </Button>
        <Button variant="outline" onClick={() => window.location.href = '/'}>
          Ir para início
        </Button>
      </div>
      {import.meta.env.DEV && error instanceof Error && (
        <pre className="text-left text-xs bg-muted p-4 rounded-md overflow-auto max-w-2xl">
          {error.message}
        </pre>
      )}
    </div>
  </div>
);

export const SentryErrorBoundary = Sentry.withErrorBoundary(
  ({ children }: { children: React.ReactNode }) => <>{children}</>,
  {
    fallback: ErrorFallback,
    showDialog: false,
  }
);
